import React from 'react';
import styles from './universities-filter.module.scss';
import { IToggleButton } from '../../../models/toggle-button/IToggleButton';
import { sanitizeText } from '../../../utils/string-helpers/formatting.helper';
import ToggleButtonGroup from '../toggle-button-group/toggle-button-group';

type Props = {
  filterOptions: IToggleButton[];
  filterByLabel: string;
  heapIdentifier: string;
};

export default function UniversitiesListFilters({
  filterOptions,
  filterByLabel,
  heapIdentifier,
}: Props) {
  const id = sanitizeText(filterByLabel);

  return (
    <div className={`${styles.filter_buttons}`} role='group' aria-labelledby={id}>
      <label className={styles.filter_by} id={id} htmlFor={`label-for-${id}`}>
        <span className='visually-hidden'>Filter by</span> {filterByLabel}
      </label>
      <div
        className='button-group'
        id={`label-for-${id}`}
        aria-label={`use arrow keys here to filter by ${filterByLabel}`}
      >
        {filterOptions && (
          <ToggleButtonGroup toggleButtonProps={filterOptions} heapIdentifier={heapIdentifier} />
        )}
      </div>
    </div>
  );
}
